import { jsx as _jsx } from "react/jsx-runtime";
import { emptyDecorator } from '@/catalog/constants/emptyDecorator';
import { FieldType } from '@/catalog/constants/fieldTypes';
import HueDescription from '@/color/components/HueDescription/HueDescription';
import { getFullHueName } from '@/color/helpers/hueUtils';
import { ALL_CONTEXTS } from '@/common/constants/context';
import Diamond from '@/product/entity/Diamond';
import Gem from '@/product/entity/Gem';
export const FIELD_MUNSELL = {
    label: 'Color Hue',
    fullLabel: 'Color Hue',
    key: 'hue',
    type: FieldType.Scalar,
    icon: 'octonus-color',
    getter(p) {
        if ((p instanceof Diamond || p instanceof Gem) && p.munsellMetric) {
            return _jsx(HueDescription, { hue: p.munsellMetric.fineStepHue });
        }
        return null;
    },
    getterPlain(p) {
        if ((p instanceof Diamond || p instanceof Gem) && p.munsellMetric) {
            return getFullHueName(p.munsellMetric.fineStepHue);
        }
        return null;
    },
    decorator: emptyDecorator,
    iteratee: null,
    contexts: ALL_CONTEXTS,
};
